module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-start-btn-7c26215c.svg";